module.exports = __webpack_public_path__ + "static/media/holistic-pic.5a6c7d5d.jpeg";